export default {
  highcharts: {
    decimalPoint: ',',
    downloadJPEG: 'Pobierz obraz JPEG',
    downloadPDF: 'Pobierz dokument PDF',
    downloadPNG: 'Pobierz obraz PNG',
    downloadSVG: 'Pobierz obraz SVG',
    exportButtonTitle: 'Eksport',
    forexRate: 'Kurs średni FOREX',
    loading: 'Ładowanie...',
    months: [
      'Styczeń',
      'Luty',
      'Marzec',
      'Kwiecień',
      'Maj',
      'Czerwiec',
      'Lipiec',
      'Sierpień',
      'Wrzesień',
      'Październik',
      'Listopad',
      'Grudzień',
    ],
    printButtonTitle: 'Drukowanie',
    rangeSelectorFrom: 'Od',
    rangeSelectorTo: 'Do',
    rangeSelectorZoom: 'Przybliżenie',
    rateTypes: {
      ask: 'Najlepsza oferta sprzedaży',
      bid: 'Najlepsza oferta kupna',
      forex: 'Średni kurs na świecie',
    },
    resetZoom: 'Reset',
    resetZoomTitle: 'Reset',
    shortMonths: ['Sty', 'Lut', 'Mar', 'Kwi', 'Maj', 'Cze', 'Lip', 'Sie', 'Wrz', 'Paź', 'Lis', 'Gru'],
    thousandsSep: ' ',
    weekdays: ['Niedziela', 'Poniedziałek', 'Wtorek', 'Środa', 'Czwartek', 'Piątek', 'Sobota'],
    wtBestAsk: 'Najlepsza oferta sprzedaży',
    wtBestBid: 'Najlepsza oferta kupna',
  },
  calculator: {
    title: "Calculer l'épargne en Walutomat",
    rangeFrom: 'Je souhaite',
    forBuy: 'pour',
    forSell: 'à',
    directionBuy: 'Acheter',
    directionSell: 'Vendre',
    payText: 'vous paierez',
    sellText: 'vous recevrez',
    buySelect: 'acheter',
    sellSelect: 'vendre',
    rateText: 'Taux de change',
    amountText: 'Montant',
    includes: 'Comprend',
    commission: '{{commission}}% commission',
    howItWorks: '',
    banksComapreOpen: "Comparer avec d'autres",
    banksComapreClose: 'Réduire la liste',
    savingsMonthly: "Avec Walutomat, vous n'économisez qu'une seule fois",
    savingsYearly: "remplaçant tout au long de l'année, chaque mois.",
    conjunction: 'et',
    serverError: 'Erreur de communication du serveur',
    unsupportedPair: "Nous n'offrons pas actuellement de taux pour la paire de devises sélectionnée.",
    infoError: {
      exchange: 'Sur Walutomat.pl vous pouvez directement échanger',
      transactionFee:
        "et inversement. Une telle transaction à la banque est associée à des frais élevés, atteignant généralement 5 à 10 % du montant de l'échange.",
    },
    spinnerError: 'Il y a eu un problème avec le téléchargement des données',
  },
  dashboard: {
    canEditPost: 'Możesz edytować wpis',
    postExists: 'Wpis o takim tytule już istnieje',
    postNotExists: 'Wpis o takim tytule nie istnieje',
    emptyPostTitle: 'Dodaj tytuł wpisu',
    error: 'Coś poszło nie tak :(',
  },
  widgetCalculator: {
    title: 'Vérifiez les taux et changez vos devises dans Walutomat – rapidement et à des conditions avantageuses.',
    actualRate: 'Taux actuel',
    exchangeAmount: "Valeur de l'échange",
    buySelect: "Valeur de l'échange",
    sellSelect: 'Je vends',
    buttonText: 'Convertir',
    buyRateTooltip:
      "Ce taux signifie que nous vous vendrons {{buyCurrency}} au {{exchangeRate}} {{sellCurrency}}. Plus il est bas, plus c'est avantageux pour vous. Nous le mettons à jour toutes les 30 secondes.",
    sellRateTooltip:
      "Ce taux signifie que nous vous achèterons {{buyCurrency}} à {{exchangeRate}} {{sellCurrency}}. Plus il est élevé, plus c'est avantageux pour vous. Nous le mettons à jour toutes les 30 secondes.",
  },
  formValidation: {
    emptyField: 'Le champ ne peut pas être vide',
    requiredField: 'Le champ est obligatoire',
    passwordToShort: 'Le mot de passe doit comporter 8 caractères',
    emailNotValid: 'Le champ doit contenir une adresse électronique valide',
    emailReserved: "L'adresse électronique est déjà prise",
    rateEmpty: 'Tous les champs doivent être remplis',
    serverUnknownError: 'Erreur de communication avec le serveur',
    invalidCharacters: 'Le champ contient des caractères non valides',
    phoneNotValid: 'Le numéro de téléphone est incorrect',
    checkBoxBelow: 'Veuillez cocher la case ci-dessous pour envoyer un message',
  },
  password: {
    show: 'afficher',
    hide: 'cacher',
  },
  howItWorks: {
    showButton: 'Afficher plus',
    hideButton: 'Afficher moins',
  },
}
